const tabs = document.querySelectorAll('.product-specifications .specification-tab'),
  content = document.querySelectorAll('.product-specifications .tab-content');

function activeCategoryHandler(index, array) {
  array.forEach(item => {
    item.dataset.index != index ?
      item.classList.remove('is-active') :
      item.classList.add('is-active');
  });
}

tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    activeCategoryHandler(tab.dataset.index, tabs);
    activeCategoryHandler(tab.dataset.index, content);
  })
});

activeCategoryHandler(1, tabs);
activeCategoryHandler(1, content);